import { CalendarDate } from '@internationalized/date';
import {
  LoadLineItemInput,
  WeightDisplayUnit,
} from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const updateBrokeredLoadAtom = createMutationAtomFactory(
  'brokerage.updateBrokeredLoad',
  (params: {
    id: string;
    expectedShipDate?: CalendarDate;
    supplierId?: string | null;
    facilityId?: string | null;
    salesOrderId?: string | null;
    bookingId?: string | null;
    brokeredOrderId?: string | null;
    deliveryNumber?: string | null;
    releaseNumber?: string | null;
    truckNumber?: string | null;
    trailerNumber?: string | null;
    containerNumber?: string | null;
    sealNumber?: string | null;
    recyclerInternalNotes?: string | null;
    recyclerExternalNotes?: string | null;
    lineItems?: LoadLineItemInput[];
    weightDisplayUnit?: WeightDisplayUnit | null;
  }) => ({
    tradeLoadUpdate: {
      __args: {
        id: params.id,
        input: {
          expectedShipDate: params.expectedShipDate?.toString(),
          supplierId: params.supplierId,
          facilityId: params.facilityId,
          salesOrderId: params.salesOrderId,
          bookingId: params.bookingId,
          brokeredOrderId: params.brokeredOrderId,
          deliveryNumber: params.deliveryNumber,
          releaseNumber: params.releaseNumber,
          truckNumber: params.truckNumber,
          trailerNumber: params.trailerNumber,
          containerNumber: params.containerNumber,
          sealNumber: params.sealNumber,
          recyclerInternalNotes: params.recyclerInternalNotes,
          recyclerExternalNotes: params.recyclerExternalNotes,
          lineItems: params.lineItems,
          weightDisplayUnit: params.weightDisplayUnit,
        },
      },
      load: {
        id: true,
        status: true,
        expectedShipDate: true,
        supplierId: true,
        supplier: {
          id: true,
          name: true,
        },
        brokeredOrderId: true,
        brokeredOrder: {
          id: true,
          orderNumber: true,
        },
        salesOrderId: true,
        salesOrder: {
          id: true,
          documentNumber: true,
          account: {
            id: true,
            name: true,
          },
        },
        bookingId: true,
        booking: {
          id: true,
          documentNumber: true,
        },
        facilityId: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    },
  }),
);
